module.exports = __webpack_public_path__ + "img/bg.202964e.jpg";